import { useState, useEffect } from 'react';
import { Box} from '@chakra-ui/react';  // Import from @chakra-ui/react
// import { TfiBell as BellIcon } from 'react-icons/tfi';
// import Logo from '../../Images/logo.png';
import css from '../../css/header.module.css';
import { Link } from 'react-router-dom';
import { convertTimetoString } from '../../helperFunction';

const NavBar = () => {
  const [currentDate, setCurrentDate] = useState<string | any>('');  // Remove the default value

  useEffect(() => {
    let d = new Date();
    let cTime = convertTimetoString(d, 0);
    setCurrentDate(cTime);
  }, []);

  return (
    <Box as="header" className={css.container}>  {/* Use 'as' instead of 'component' */}
      <Link to="/dashboard/overview" className={css.logo}>
      </Link>
      <Box className={css.navDiv}>  {/* Replace Typography with Box */}
        <div className={css.notificationDiv}>
          {/* <span><BellIcon /></span> */}
          <Box className={css.notification}>  {/* Replace Typography with Box */}
            {/* Notification content goes here */}
          </Box>
        </div>
        <div style={{fontSize:'13px'}}>
          {currentDate ? currentDate : ''}
        </div>
      </Box>
    </Box>
  );
}

export default NavBar;
